import { useState, useRef, useEffect } from 'react';
import Close from '@mui/icons-material/Close';
import {
  EvidenceTrigger,
  StyledPopover,
  PopoverMouseArea,
  PopoverContent,
  PopoverCloseButton,
  PopoverTitle,
  ReferenceBox,
  ReferenceLink,
  ReferenceIcon,
  ReferenceText,
  ReferenceTextItalic,
} from './styles';

const EvidencePopover = ({ stat }) => {
  const [isOpen, setIsOpen] = useState(false);
  const anchorRef = useRef(null);
  const openTimeoutRef = useRef(null);
  const closeTimeoutRef = useRef(null);

  const handlePopoverOpen = () => {
    if (closeTimeoutRef.current) {
      clearTimeout(closeTimeoutRef.current);
    }
    if (openTimeoutRef.current) {
      clearTimeout(openTimeoutRef.current);
    }
    openTimeoutRef.current = setTimeout(() => {
      setIsOpen(true);
    }, 500);
  };

  const handlePopoverClose = () => {
    if (openTimeoutRef.current) {
      clearTimeout(openTimeoutRef.current);
    }
    if (closeTimeoutRef.current) {
      clearTimeout(closeTimeoutRef.current);
    }
    closeTimeoutRef.current = setTimeout(() => {
      setIsOpen(false);
    }, 200);
  };

  const handlePopoverMouseEnter = () => {
    if (openTimeoutRef.current) {
      clearTimeout(openTimeoutRef.current);
    }
    if (closeTimeoutRef.current) {
      clearTimeout(closeTimeoutRef.current);
    }
    setIsOpen(true);
  };

  const handlePopoverMouseLeave = () => {
    if (closeTimeoutRef.current) {
      clearTimeout(closeTimeoutRef.current);
    }
    closeTimeoutRef.current = setTimeout(() => {
      setIsOpen(false);
    }, 200);
  };

  useEffect(() => {
    return () => {
      if (openTimeoutRef.current) {
        clearTimeout(openTimeoutRef.current);
      }
      if (closeTimeoutRef.current) {
        clearTimeout(closeTimeoutRef.current);
      }
    };
  }, []);

  return (
    <>
      <EvidenceTrigger
        ref={anchorRef}
        component="span"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
      >
        View evidence
      </EvidenceTrigger>

      <StyledPopover
        open={isOpen}
        anchorEl={anchorRef.current}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        disableRestoreFocus
      >
        <PopoverMouseArea
          onMouseEnter={handlePopoverMouseEnter}
          onMouseLeave={handlePopoverMouseLeave}
        >
          <PopoverContent>
            <PopoverCloseButton onClick={handlePopoverClose}>
              <Close />
            </PopoverCloseButton>
            <PopoverTitle variant="h4">References</PopoverTitle>
            {stat.references?.length > 0 &&
              stat.references.map((reference, refIndex) => (
                <ReferenceBox key={refIndex}>
                  {reference.text.map((textItem, textIndex) => {
                    if (textItem.type === 'link') {
                      return (
                        <ReferenceLink
                          key={textIndex}
                          href={textItem.href}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {textItem.text}
                          <ReferenceIcon />
                        </ReferenceLink>
                      );
                    }
                    if (textItem.type === 'italic') {
                      return (
                        <ReferenceTextItalic key={textIndex} variant="body2" component="span">
                          {textItem.content}
                        </ReferenceTextItalic>
                      );
                    }
                    return (
                      <ReferenceText key={textIndex} variant="body2" component="span">
                        {textItem.content}
                      </ReferenceText>
                    );
                  })}
                </ReferenceBox>
              ))}
          </PopoverContent>
        </PopoverMouseArea>
      </StyledPopover>
    </>
  );
};

export default EvidencePopover;
